/** Invalid or missing profile timezones must never silently show the viewer's time. */
export function formatPeerLocalTime(timezone: string | null | undefined, now: Date): string | null {
  if (!timezone) return null;
  try {
    const time = new Intl.DateTimeFormat(undefined, {
      timeZone: timezone, hour: "numeric", minute: "2-digit",
    }).format(now);
    return `${time} · ${timezone.replace(/_/g, " ")}`;
  } catch {
    return null;
  }
}
